import api from '..'

export const createPayment = (body) => {
  return api.post('/payments', body, 'bearer')
}
